// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TableLabelWithIcon__tableName___pur3Y{display:flex;align-items:center;padding:2px 0}.TableLabelWithIcon__tableNameIcon___2CVY_{width:24px;height:24px;display:flex;align-items:center;justify-content:center;margin-right:16px}.TableLabelWithIcon__tableNameText___39ipG{font-size:14px;color:#333}\n", ""]);
// Exports
exports.locals = {
	"tableName": "TableLabelWithIcon__tableName___pur3Y",
	"tableNameIcon": "TableLabelWithIcon__tableNameIcon___2CVY_",
	"tableNameText": "TableLabelWithIcon__tableNameText___39ipG"
};
module.exports = exports;
